module.exports = __webpack_public_path__ + "static/media/mainpage-phones.9cc01ee0.png";